import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import  API, { getEvaPorId, deleteExamen, patchEva, getConclusionMedica, generarPDF, getAnexosEva } from '../services/api';
import { formatearVigencia } from '../utils/vigencia';
import AnexoViewerModal from './AnexoViewerModal';
import { confirmar } from './ConfirmModal';
import { toast } from 'react-toastify';
import '../styles/styles.css';
import '../styles/modal.css';

const PanelExamenes = () => {
  const { evaluacionId } = useParams();
  const navigate = useNavigate();
  const [tiposExamen, setTiposExamen] = useState([]);
  const [conclusionMedica, setConclusionMedica] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [revisadoEva, setRevisadoEva] = useState(false);
  const [pendienteEva, setPendienteEva] = useState(false);

  // Anexos subidos por la empresa (se listan siempre, sin importar el estado de "pendiente")
  const [anexos, setAnexos] = useState([]);
  const [anexoVer, setAnexoVer] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getEvaPorId(evaluacionId);
        setTiposExamen(response.data.tipos_examen || []);
        setRevisadoEva(response.data.revisado || false);
        setPendienteEva(response.data.pendiente || false);
        // Llamar a conclusion médica aparte
        try {
          const conclRes = await getConclusionMedica(evaluacionId);
          setConclusionMedica(conclRes.data);
        } catch (error) {
          if (error.response && error.response.status === 404) {
            setConclusionMedica(null);
          } else {
            console.error("Error cargando conclusión médica:", error);
            toast.error("No se pudo cargar la conclusión médica.");
          }
        }
        // Anexos: se listan independiente del estado de revisado/pendiente
        try {
          const anexosRes = await getAnexosEva(evaluacionId);
          setAnexos(anexosRes.data || []);
        } catch (error) {
          console.error("Error cargando anexos:", error);
          toast.error("No se pudo cargar la lista de anexos.");
        }
      } catch (error) {
        console.error("Error cargando evaluación:", error);
        setError("No se pudo cargar la evaluación.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [evaluacionId]);

  const handleCerrarModalAnexo = () => {
    setAnexoVer(null);
  };

  const handleVerAnexo = (anexo) => {
    setAnexoVer(anexo);
  };


  const crearExamen = (te) => {
    navigate(`/evaluaciones/${evaluacionId}/examenes/crear/${te.codigo}`,
      {state: {parametros_sol: te.parametros_sol}}
    );
  };

  const editarExamen = (te) => {
    navigate(`/evaluaciones/${evaluacionId}/examenes/editar/${te.id_examen}`,
      {state: {parametros_sol: te.parametros_sol}}
    );
  };

  const borrarExamen = async (id_examen) => {
    try {
      await deleteExamen(evaluacionId, id_examen);
      toast.success("Examen borrado exitosamente");
      setTiposExamen(prev =>
        prev.map(te =>
          te.id_examen === id_examen ? { ...te, examen_creado: false, id_examen: null } : te
        )
      );
      setRevisadoEva(false);
      setPendienteEva(false);
    } catch (error) {
      console.error("Error borrando examen:", error);
      toast.error(error.response?.data?.message || "No se pudo borrar el examen");
    }
  };

  const todosExamenesCreados = tiposExamen.length > 0 && tiposExamen.every(te => te.examen_creado);
  const puedeMarcarRevisado = todosExamenesCreados && conclusionMedica;

  const marcarRevisado = async (checked) => {
    if (!checked && !(await confirmar("¿Estás seguro que quieres desmarcar de revisado la evaluación? Se borrará el PDF generado.", { variante: 'peligro' }))) {
      return;
    }
    try {
      await patchEva(evaluacionId, { revisado: checked });
      toast.success(checked ? "Evaluación marcada como revisada" : "Evaluacion desmarcada");
      setRevisadoEva(checked);
      if (!checked && pendienteEva) {
        await patchEva(evaluacionId, { pendiente: false });
        setPendienteEva(false);
      }
    } catch (error) {
      console.error("Error marcando revisado:", error);
      toast.error("No se pudo marcar como revisado");
    }
  };

  const marcarPendiente = async (checked) => {
    const mensaje = checked
      ? "¿Estás seguro de que deseas MARCAR esta evaluación como PENDIENTE?"
      : "¿Estás seguro de que deseas DESMARCAR la evaluación de PENDIENTE?";
    if (!(await confirmar(mensaje))) return;
    try{
      await patchEva(evaluacionId,{pendiente:checked});
      setPendienteEva(checked);
      toast.success(checked ? "Evaluación marcada como pendiente" : "Evaluación quitada de pendientes");
    }catch(error){
      console.error("Error marcando pendiente:", error);
      toast.error("No se pudo marcar el estado pendiente");
    }
  }


  const handleGenerarPDF = async () => {
    try {
      const response = await generarPDF(evaluacionId);

      if (response.data && response.data.id_pdf) {
        toast.success("PDF generado correctamente");
        const pdfUrl = `${API.defaults.baseURL}/evaluaciones/${evaluacionId}/pdf/${response.data.id_pdf}`;
        window.open(pdfUrl, "_blank");
      } else {
        toast.error("No se pudo obtener el ID del PDF generado");
      }
    } catch (error) {
      console.error("Error generando PDF:", error);
      toast.error("No se pudo generar el PDF");
    }
  };

  if (loading) return <div>Cargando exámenes...</div>;

  if (error) return <p className="required-text">{error}</p>;

  return (
    <div className="content-wrapper">
      <h1>Panel de Exámenes</h1>
      <div className='btn-group-h' >
        {todosExamenesCreados && (
          <button className="btn btn-create" onClick={() => navigate(`/evaluaciones/${evaluacionId}/revisar`)} >
            Revisar examenes y agregar conclusion médica
          </button>
        )}
        {puedeMarcarRevisado && (
          <div className="form-block">
            <label>
              <input
                type="checkbox"
                checked={revisadoEva}
                onChange={(e) => marcarRevisado(e.target.checked)}
              />
              Evaluacion revisada
            </label>
          </div>
        )}
        {revisadoEva && (
          <div className="form-block">
            <label>
              <input
                type="checkbox"
                checked={pendienteEva}
                onChange={(e) => marcarPendiente(e.target.checked)}
              />
              Marcar como pendiente
            </label>
          </div>
        )}
        {revisadoEva && conclusionMedica && (
          <button className="btn btn-secondary" onClick={handleGenerarPDF}>
            Generar PDF
          </button>
        )}
      </div>

      <div className="exam-grid">
        {tiposExamen.map(te => (
          <div key={te.codigo} className="exam-card">
            <h3>{te.nombre}</h3>
            {te.examen_creado ? (
              <div className="btn-group">
                <button className="btn btn-secondary" onClick={() => editarExamen(te)}>Editar</button>
                <button className="btn btn-danger" onClick={() => borrarExamen(te.id_examen)}>Borrar</button>
              </div>
            ) : (
              <button className="btn btn-create" onClick={() => crearExamen(te)}>Crear Examen</button>
            )}
          </div>
        ))}
      </div>
      {conclusionMedica && (
        <div className="conclusion-card">
          <h2>Conclusión Médica</h2>
          <p><strong>Resumen:</strong> {conclusionMedica.resumen}</p>
          <p><strong>Recomendaciones:</strong> {conclusionMedica.recomendaciones}</p>
          <p><strong>Indicaciones:</strong> {conclusionMedica.indicaciones}</p>
          <p><strong>Guía Médica:</strong> {conclusionMedica.guia_medica}</p>
          <p><strong>Vigencia:</strong> {formatearVigencia(conclusionMedica.vigencia)}</p>
        </div>
      )}

      {/* Anexos subidos por la empresa: se listan siempre, aunque la evaluación ya no esté pendiente */}
      <div className="container">
        <h2>Anexos Adjuntos</h2>
        {anexos.length > 0 ? (
          <ul className="anexos-lista">
            {anexos.map((anexo) => (
              <li key={anexo.id_anexo}>
                <button
                  type="button"
                  onClick={() => handleVerAnexo(anexo)}
                  className="btn-icon btn-secondary"
                  title={anexo.observaciones || anexo.original_name}
                >
                  <i className="fas fa-paperclip"></i>{' '}
                  <span className="filename-truncado">{anexo.original_name || anexo.filename}</span>
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ color: '#888' }}>No hay anexos adjuntos para esta evaluación.</p>
        )}
      </div>

      {/* Modal Visualizador de Anexo (Blob) */}
      {anexoVer && (
        <AnexoViewerModal
          idEva={evaluacionId}
          anexo={anexoVer}
          onClose={handleCerrarModalAnexo}
        />
      )}

    </div>
  );
};

export default PanelExamenes;